import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {initialUsersState} from "../state/UsersState";
import {UserDto} from "../domain/UserDto";
import {LoginAuditDto} from "../domain/LoginAuditDto";

export const usersSlice = createSlice({
    name: "users",
    initialState: initialUsersState,
    reducers: {
        setUsers(state, {payload}: PayloadAction<UserDto[]>) {
            state.users = payload;
        },

        setLoginAudits(state, {payload}: PayloadAction<LoginAuditDto[]>) {
            state.logins = payload;
        },
        selectLoginAudits(state, {payload}: PayloadAction<LoginAuditDto[]>) {
            state.selectedLogins = payload;
        },
        toggleSelectAllLoginAudits(state) {
            state.selectedLogins = state.selectedLogins.length > 0 ? [] : state.logins;
        },
    },
});

export namespace UsersActions {
    export const {
        setUsers,

        setLoginAudits,
        selectLoginAudits,
        toggleSelectAllLoginAudits,
    } = usersSlice.actions;
}
